<div class="payment-failure-container" *ngIf="!loading && paymentFailureData">
  <div class="payment-failure-card">
    <!-- Failure Header -->
    <div class="failure-header">
      <div class="failure-icon-circle">
        <i class="pi pi-times"></i>
      </div>
      <h1 class="failure-title">Payment Failed</h1>
      <p class="failure-subtitle">Your payment could not be processed</p>
    </div>

    <!-- Order Information -->
    <div class="order-info-section">
      <div class="info-row">
        <div class="info-item">
          <span class="info-label">Order ID</span>
          <span class="info-value">{{ paymentFailureData.orderId }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Transaction ID</span>
          <span class="info-value">{{ paymentFailureData.transactionId }}</span>
        </div>
      </div>
      <div class="info-row">
        <div class="info-item full-width">
          <span class="info-label">Failure Date</span>
          <span class="info-value">{{ paymentFailureData.failureDate }}</span>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Failure Reason -->
    <div class="failure-reason-section" *ngIf="paymentFailureData.failureReason">
      <div class="section-header">
        <i class="pi pi-exclamation-triangle section-icon"></i>
        <h3 class="section-title">Failure Reason</h3>
      </div>
      <div class="failure-reason-content">
        <p class="failure-reason-text">{{ paymentFailureData.failureReason }}</p>
      </div>
    </div>

    <div class="divider" *ngIf="paymentFailureData.failureReason"></div>

    <!-- Customer Details -->
    <div class="details-section">
      <div class="section-header">
        <i class="pi pi-user section-icon"></i>
        <h3 class="section-title">Customer Details</h3>
      </div>
      <div class="details-content">
        <div class="detail-item">
          <span class="detail-label">Name:</span>
          <span class="detail-value">{{ paymentFailureData.customer.name }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Email:</span>
          <span class="detail-value">{{ paymentFailureData.customer.email }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Phone:</span>
          <span class="detail-value">{{ paymentFailureData.customer.phone }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Address:</span>
          <span class="detail-value">{{ paymentFailureData.customer.address }}</span>
        </div>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Package Details -->
    <div class="details-section">
      <div class="section-header">
        <i class="pi pi-box section-icon"></i>
        <h3 class="section-title">Package Details</h3>
      </div>
      <div class="package-content">
        <h4 class="package-name">{{ paymentFailureData.package.name }}</h4>
        <p class="services-label">SERVICES INCLUDED:</p>
        <ul class="services-list">
          <li *ngFor="let service of paymentFailureData.package.services">
            <i class="pi pi-check-circle check-icon"></i>
            <span>{{ service }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="divider"></div>

    <!-- Payment Summary -->
    <div class="details-section">
      <div class="section-header">
        <i class="pi pi-money-bill section-icon"></i>
        <h3 class="section-title">Payment Summary</h3>
      </div>
      <div class="payment-summary">
        <div class="summary-row">
          <span class="summary-label">Package Amount</span>
          <span class="summary-value">₹{{ paymentFailureData.amount.toLocaleString('en-IN') }}</span>
        </div>
        <div class="summary-row total-row">
          <span class="summary-label total-label">Total Amount</span>
          <span class="summary-value total-value">₹{{ paymentFailureData.amount.toLocaleString('en-IN') }}</span>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <p-button
        label="Try Again"
        icon="pi pi-refresh"
        (onClick)="tryAgain()"
        styleClass="try-again-btn"
      ></p-button>
      <p-button
        label="Contact Support"
        icon="pi pi-envelope"
        iconPos="left"
        (onClick)="contactSupport()"
        styleClass="contact-support-btn"
      ></p-button>
    </div>
  </div>

  <!-- Footer Message -->
  <p class="help-message">
    If you continue to experience issues, please contact our support team at <a href="mailto:support&#64;gradpilots.com">support&#64;gradpilots.com</a>
  </p>
</div>

<!-- Loading State -->
<div class="payment-failure-container" *ngIf="loading">
  <div class="payment-failure-card">
    <div class="loading-state">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
      <p>Loading transaction details...</p>
    </div>
  </div>
</div>

